import { render } from "./JobApprovalTask.vue?vue&type=template&id=1123ac03"
import script from "./JobApprovalTask.vue?vue&type=script&lang=js"
export * from "./JobApprovalTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__